import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { showErrorMessage, testHtmlRegex } from '../../helpers/helpers';

@Component({
  selector: 'app-radio-button-wrapper',
  templateUrl: './radio-button-wrapper.component.html',
  styleUrls: ['./radio-button-wrapper.component.scss']
})
export class RadioButtonWrapperComponent extends FieldWrapper implements OnInit {
  @ViewChild('form') elementView: ElementRef;
  isHtml : boolean = false;
  isMarginRequired:boolean = true;
  showErrMessage = showErrorMessage;

  ngOnInit(): void {
    this.isHtml = testHtmlRegex(this.props.description);
  }
  
  ngAfterViewInit(){
    if(this.elementView?.nativeElement?.offsetHeight > 80){
      this.isMarginRequired = false;
    }
  }

}
